import React from "react";
import DynamicButton from "../DynamicButton/DynamicButton";
import "./ActCard.scss";
// import { useHistory } from "react-router";
import moment from "moment";
import { definePropozuesi, defineType } from "helpers/Denfiners";

export const ActCard = ({
  title = "",
  time,
  type,
  id,
  propozuesi,
  t,
  struktura,
  buttonText,
  url,
  Date_Miratimi,
}) => {
  // Helper to check if type is one of the 'Projekt...' types
  const isProjektTypeString = (typeStr) =>
    [
      "Projektligj",
      "ProjektVendim",
      "ProjektRezolute",
      "ProjektDeklarate",
    ].includes(typeStr);
  const PROJEKT = "projekt";
  const DATE_MIRATIMI_LABEL = t("allActsPage.actCard.approvalDate");
  const DATE_DEPOZITIMI = t("allActsPage.actCard.depositDate");
  // const history = useHistory();

  return (
    <div className="act-card-wrapper">
      <div className="act-top-details">
        <h5>{title}</h5>
        {type !== undefined && type !== null && !isNaN(Number(type)) && (
          <h6>
            {t("allActsPage.actCard.actType")}: {defineType(Number(type))}
          </h6>
        )}
        {type !== undefined &&
          type !== null &&
          !isNaN(Number(type)) &&
          defineType(Number(type)) &&
          defineType(Number(type)).toLowerCase().includes(PROJEKT) && (
            <h6>
              {t("allActsPage.actCard.proposer")}:{" "}
              {definePropozuesi(propozuesi)}
            </h6>
          )}
        {struktura && (
          <h6>
            {t("allActsPage.actCard.structure")}: {struktura}
          </h6>
        )}
      </div>
      <div className="act-bottom-details">
        {((time && time.dt_dep) || Date_Miratimi) && (
          <>
            {time && time.dt_dep && (
              <span>
                {DATE_DEPOZITIMI}: {moment(time.dt_dep).format("MMMM Do YYYY")}
              </span>
            )}
            {/* Only show Date_Miratimi if not a 'Projekt...' type */}
            {Date_Miratimi && !isProjektTypeString(defineType(Number(type))) && (
              <span style={{ marginLeft: time && time.dt_dep ? "10px" : "0" }}>
                {DATE_MIRATIMI_LABEL}:{" "}
                {moment(Date_Miratimi).format("MMMM Do YYYY")}
              </span>
            )}
          </>
        )}
        <DynamicButton
          text={buttonText || t("allActsPage.actCard.more")}
          action={() => {
            if (type === null) {
              const win = window.open(url, "_blank");
              win.focus();
            } else {
              const win = window.open(`/dokumentacioni/aktet/${id}`, "_blank");
              win.focus();
            }
            // history.push(`/dokumentacioni/aktet/${id}`);
          }}
          type="view-act"
        />
      </div>
    </div>
  );
};
